import Marquee from "react-fast-marquee";

const items = [
  "Commercial & Residential",
  "Craftsmanship & Reliability",
  "Florida & Virginia",
  "Built To Last",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative py-14 md:py-20 border-y border-brand-hi bg-brand-navy overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-stroke mx-8">
              {item}
            </span>
            <span className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-brand-orange shrink-0" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
